import {
    IconComponent,
    VvUtvIcon,
    VvAtvIcon,
    VvCruiserIcon,
    VvScooterIcon,
    VvTractorIcon,
    VvTrikeIcon,
    VvDirtBikeIcon,
    VvSportsBikeIcon,
    VvSnowmobileIcon,
    VvEBikeIcon,
    VvGoKartIcon,
    VvGolfCartIcon,
    VvJetskiIcon,
} from '@octane/spark'

interface IconMap {
    utv: IconComponent
    atv: IconComponent
    cruiser: IconComponent
    scooter: IconComponent
    trike: IconComponent
    'electric bike': IconComponent
    'go kart': IconComponent
    'golf cart': IconComponent
    tractor: IconComponent
    pwc: IconComponent
    snowmobile: IconComponent
    'dirt bike': IconComponent
    'sports bike': IconComponent
    'sport bike': IconComponent
}

const iconMap: IconMap = {
    utv: VvUtvIcon,
    atv: VvAtvIcon,
    cruiser: VvCruiserIcon,
    scooter: VvScooterIcon,
    trike: VvTrikeIcon,
    'electric bike': VvEBikeIcon,
    'go kart': VvGoKartIcon,
    'golf cart': VvGolfCartIcon,
    tractor: VvTractorIcon,
    pwc: VvJetskiIcon,
    snowmobile: VvSnowmobileIcon,
    'dirt bike': VvDirtBikeIcon,
    'sports bike': VvSportsBikeIcon,
    'sport bike': VvSportsBikeIcon,
}

export type VehicleType = keyof typeof iconMap

const getVehicleTypeIcon = (vehicleType: VehicleType) => {
    return iconMap[vehicleType]
}

export default getVehicleTypeIcon
